module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "has-text-centered"
  }, [_vm._v("Våra favoriter")]), _vm._v(" "), _vm._l((_vm.topFavoriteList), function(user, index) {
    return _c('div', {
      key: index
    }, [_c('user-beers', {
      attrs: {
        "user": user
      }
    })], 1)
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e7029d36", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7029d36"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/facts/TopFavorites.vue
// module id = 159
// module chunks = 1